/**
 * Logos are swapped purely via CSS using the [data-theme] attribute, which is
 * set on <html> by an inline script in index.html BEFORE first paint. This
 * guarantees the correct logo shows instantly with zero flash (no dependency on
 * React/useTheme hydration). Both images are in the DOM; CSS shows the right one.
 */
export function LogoWordmark({ className = "h-9" }) {
  const imgClass = `${className} w-auto object-contain select-none`;
  return (
    <span className="logo-swap inline-flex items-center" data-testid="acquireloop-logo">
      <img className={`logo-light ${imgClass}`} src="/acquireloop-wordmark.png" alt="AcquireLoop by Proffus" draggable={false} />
      <img className={`logo-dark ${imgClass}`} src="/acquireloop-wordmark-dark.png" alt="AcquireLoop by Proffus" draggable={false} />
    </span>
  );
}

export function LogoIcon({ className = "h-9 w-9" }) {
  const imgClass = `${className} object-contain select-none`;
  return (
    <span className="logo-swap inline-flex items-center" data-testid="acquireloop-icon">
      <img className={`logo-light ${imgClass}`} src="/acquireloop-icon.png" alt="AcquireLoop" draggable={false} />
      <img className={`logo-dark ${imgClass}`} src="/acquireloop-icon-dark.png" alt="AcquireLoop" draggable={false} />
    </span>
  );
}
